import uniq from './uniq';

const union = function(...sources) {
  return uniq([].concat(...sources));
};

export default union;
